import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  input,
  OnInit,
  signal,
} from '@angular/core';
import { ApplicationContextCardComponent } from './components/application-context-card/application-context-card.component';
import { UserApi } from '../../../shared/services/api/user.api';
import { ApplicationContextService } from '../../../core/services/application-context.service';
import { Organizacja } from '../../../shared/models/organizacja';
import { Beneficjent } from '../../../shared/models/beneficjent';
import { OrganizationDescriptionPipe } from '../../../shared/pipes/organization-description.pipe';
import { Button } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-application-context',
  imports: [
    ApplicationContextCardComponent,
    OrganizationDescriptionPipe,
    Button,
    FormsModule,
    InputTextModule,
  ],
  templateUrl: './application-context.component.html',
  styleUrl: './application-context.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [UserApi],
})
export class ApplicationContextComponent implements OnInit {
  readonly #applicationContextService = inject(ApplicationContextService);
  readonly #authService = inject(AuthService);
  protected readonly beneficjent = input.required<Beneficjent>();
  protected showMore = signal<boolean>(false);
  protected searchTerm = signal<string>('');
  protected isUserAdmin = signal(this.#authService.isUserAdmin());

  constructor() {
    effect(() => {
      this.searchTerm();
      this.showMore.set(false);
    });
  }

  ngOnInit(): void {
    if (!this.beneficjent().zweryfikowaneDane) {
      this.#authService.updateUserDataDialog();
    }
  }

  protected filteredOrganizations = computed(() => {
    const term = this.searchTerm().toLowerCase().trim();
    const all = this.beneficjent().organizacje ?? [];

    if (!term) return all;

    return all.filter((o) => o.nazwa!.toLowerCase().includes(term));
  });

  protected visibleOrganizations = computed(() => {
    const data = this.filteredOrganizations();
    return this.showMore() ? data : data.slice(0, 4);
  });

  protected setBeneficiaryContext(event?: KeyboardEvent): void {
    if (event && event.key !== 'Enter') {
      return;
    }
    this.#applicationContextService.switchToBeneficiary();
  }

  protected setOrganizationContext(
    organization: Organizacja,
    event?: KeyboardEvent,
  ): void {
    if (event && event.key !== 'Enter') {
      return;
    }
    this.#applicationContextService.switchToOrganization(organization);
  }

  protected setAdministratorContext(event?: KeyboardEvent): void {
    if (event && event.key !== 'Enter') {
      return;
    }
    this.#applicationContextService.switchToAdmin();
  }

  protected toggleShowMore(): void {
    this.showMore.update((v) => !v);
  }
}
